export default __webpack_public_path__ + "static/media/vinotoro.7ce3354a.jpg";